import React from 'react';
import Main from './component/Main';
import { Web3ReactProvider } from "@web3-react/core";
import { POLLING_INTERVAL } from "./hooks/connectors";
import { Web3Provider } from "@ethersproject/providers";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { WagmiConfig, createConfig } from "wagmi";
import { ConnectKitProvider, getDefaultConfig } from "connectkit";
import {mainnet} from "wagmi/chains";

// Choose which chains you'd like to show
const chains = [mainnet];


export function getLibrary(provider) {
  const library = new Web3Provider(provider);
  library.pollingInterval = POLLING_INTERVAL;
  return library;
}



const config = createConfig(
  getDefaultConfig({
    // Required API Keys
    alchemyId: "D9cB4IXeA5mECQC-0p_21EqvZMdM00N-", // or infuraId
    chains,
    
    // Required
    appName: "Coin Presale",

  
  }),
);

function App() {
  return (
    <WagmiConfig config={config}>
      <ConnectKitProvider>
    <div className="App">
      <ToastContainer />
      <Web3ReactProvider getLibrary={getLibrary}>
        <Main />
      </Web3ReactProvider>
      
    </div>
    </ConnectKitProvider>
    </WagmiConfig>
  );
}

export default App;
